import { render } from "./AddKeyParametersModal.vue?vue&type=template&id=952b7f64&ts=true"
import script from "./AddKeyParametersModal.vue?vue&type=script&lang=ts"
export * from "./AddKeyParametersModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-merchant-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__